import { supabase } from '../lib/supabase';

export interface AssuntoPublico {
  id: string;
  nome: string;
  descricao: string | null;
  modulo_codigo: string;
  prazo_dias: number | null;
  forma_prestacao: 'presencial' | 'online' | 'ambos' | null;
  slug: string | null;
  publico_alvo: string | null;
  tem_custo: boolean;
}

export interface ServicoDetalhe {
  servico: {
    id: string;
    modulo_codigo: string;
    nome: string;
    descricao: string | null;
    descricao_completa: string | null;
    documentos_necessarios: string[];
    custos: Array<{ item: string; valor: string; observacao?: string; isento?: boolean }>;
    forma_prestacao: 'presencial' | 'online' | 'ambos' | null;
    publico_alvo: string | null;
    como_acompanhar: string | null;
    legislacao: string | null;
    local_atendimento: string | null;
    horario_atendimento: string | null;
    prazo_dias: number | null;
    permite_anexos: boolean;
    permite_acompanhamento_anonimo: boolean;
    slug: string | null;
  };
  unidades: Array<{ id: string; nome: string; tipo: string; endereco: string | null; bairro: string | null; telefone: string | null }>;
  area: { id: string; nome: string; descricao: string | null; cor: string | null } | null;
  estabelecimento: { id: string; nome: string; cor_primaria: string | null; logo_url: string | null };
}

export interface AreaPublica {
  id: string | null;
  nome: string;
  descricao: string | null;
  cor: string | null;
  icone: string | null;
  assuntos: AssuntoPublico[];
}

export interface AssuntoDetalhado {
  id: string;
  modulo_codigo: string;
  nome: string;
  descricao: string | null;
  modelo_inicial: string | null;
  prazo_dias: number | null;
  permite_anexos: boolean;
  permite_acompanhamento_anonimo: boolean;
  publica: boolean;
  ativo: boolean;
  area_id: string | null;
  localizacao_modo: 'nao' | 'gps' | 'mapa' | 'ambos';
  campos_customizados: Array<{
    id: string;
    nome: string;
    label: string;
    tipo: string;
    obrigatorio: boolean;
    ajuda?: string;
    placeholder?: string;
    opcoes?: Array<{ valor: string; label: string }>;
  }>;
  anexos_obrigatorios: Array<{
    id: string;
    nome: string;
    descricao?: string;
    obrigatorio: boolean;
    extensoes_permitidas: string[];
    tamanho_max_mb: number;
  }>;
  anexos_opcionais: Array<{
    id: string;
    nome: string;
    descricao?: string;
    obrigatorio: boolean;
    extensoes_permitidas: string[];
    tamanho_max_mb: number;
  }>;
}

export const cartaServicosService = {
  async listar(estabelecimentoId: string): Promise<AreaPublica[]> {
    const { data, error } = await supabase.rpc('carta_servicos_publica', { p_estabelecimento_id: estabelecimentoId });
    if (error) throw error;
    return (data ?? []) as AreaPublica[];
  },

  async buscarAssunto(assuntoId: string): Promise<AssuntoDetalhado | null> {
    const { data, error } = await supabase
      .from('assuntos')
      .select('id, modulo_codigo, nome, descricao, modelo_inicial, prazo_dias, permite_anexos, permite_acompanhamento_anonimo, publica, ativo, area_id, localizacao_modo, campos_customizados, anexos_obrigatorios, anexos_opcionais')
      .eq('id', assuntoId)
      .eq('publica', true)
      .eq('ativo', true)
      .is('deletado_em', null)
      .maybeSingle();
    if (error) throw error;
    return data as AssuntoDetalhado | null;
  },

  async buscarDetalheCarta(assuntoId: string): Promise<ServicoDetalhe | { erro: string }> {
    const { data, error } = await supabase.rpc('carta_servicos_detalhe', { p_assunto_id: assuntoId });
    if (error) throw error;
    return data as ServicoDetalhe | { erro: string };
  },

  async buscarPorSlug(estabelecimentoId: string, slug: string): Promise<ServicoDetalhe | { erro: string }> {
    const { data, error } = await supabase.rpc('carta_servicos_por_slug', {
      p_estabelecimento_id: estabelecimentoId,
      p_slug: slug,
    });
    if (error) throw error;
    return data as ServicoDetalhe | { erro: string };
  },
};
